import { Routes } from '@angular/router';

export const frontRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('src/app/front/views/home/home.component').then(module => module.HomeComponent),
        data: {
            path: 'home'
        }
    },
];
